import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(private api: ApiService) { }

  getAllTeams(data:any): Observable<any> {
    return this.api.post(environment.getAllTeam,data);
  }

  updateTeam(data:any): Observable<any> {
    return this.api.post(environment.updateTeam,data);
  }

  createTeam(data:any): Observable<any> {
    return this.api.post(environment.createTeam,data);
  }

  deleteTeam(data:any): Observable<any> {
    return this.api.post(environment.deleteTeam,data);
  }

  getAllTeamMembers(data:any): Observable<any> {
    return this.api.post(environment.getAllTeamMembers,data);
  }

  createTeamMember(data:any): Observable<any> {
    return this.api.post(environment.createTeamMember,data);
  }

  deleteTeamMember(data:any): Observable<any> {
    return this.api.post(environment.deleteTeamMember,data);
  }
  

}


